export default __webpack_public_path__ + "d2.png";